import axios from '../request/http';


const order = {
  // 服务订单列表列表
  orderList(params) {
    return axios.get("/admin/order-management/list", {
      params
    });
  },
  // 商品订单列表
  productList(params) {
    return axios.get("/admin/order-management/goods/list", {
      params
    });
  },
  // 订单评论
  getEvaluateInfo(params) {
    return axios.get("/admin/order-management/order/evaluateInfo", {
      params
    });
  },
  // 订单评论修改
  getEvaluateChange(params) {
    return axios.post("/admin/order-management/updaate/orderEvaluate", params);
  },
  // 商品订单详情 || 发货列表详情
  productDetail(params) {
    return axios.get("/admin/order-management/goods/detail", {
      params
    });
  },
  // 发货列表
  goodsCollect(params) {
    return axios.get("/admin/order-management/goods/collect", {
      params
    });
  },
  // 商品售后列表
  afterList(params) {
    return axios.get("/admin/order-management/goods/after-list", {
      params
    });
  },
  // 商品售后详情
  afterDetail(params) {
    return axios.get("/admin/order-management/goods/after-detail", {
      params
    });
  },
  // 服务售后列表
  serveList(params) {
    return axios.get("/admin/order-management/service/after-list", {
      params
    });
  },
  /**
   * 服务订单同意退款
   */
  serveAccept(params) {
    return axios.get("/admin/order-management/after-list/accept", {
      params
    });
  },
  /**
   * 服务订单拒绝退款
   */
  serveRefuse(params) {
    return axios.get("/admin/order-management/after-list/refuse", {
      params
    });
  },
  /**
   * 填写售后地址
   */
  afterAddress(params) {
    return axios.post("/admin/order-management/goods/after/upload", params);
  },
  /**
   * 商品订单售后同意拒绝退款
   */
  afterAccept(params) {
    return axios.get("/admin/order-management/goods/after-accept", {
      params
    });
  },
  /**
   * 商品售后结束
   */
  closeProduct(params) {
    return axios.get("/admin/order-management/goods/after-end", {
      params
    });
  },
  /**
   * 商品订单售后重新提交
   */
  orderManagementReset(params) {
    return axios.get("/admin/order-management/goods/after-reset", {
      params
    });
  },
  //订单售后操作记录
  operateList(params) {
    return axios.get("/admin/order-management/gteAfter/operateList", {
      params
    });
  },
  //查询售后物流信息
  afterCourier(params) {
    return axios.get("/admin/order-management/goods/after/courier", {
      params
    });
  },
  //查询申诉信息
  appealInfo(params) {
    return axios.get("/admin/order-management/after/appeal/info", {
      params
    });
  },
  //用户申诉同意or拒绝
  appealAccept(params) {
    return axios.get("/admin/order-management/after/appeal/accept", {
      params
    });
  },


}

export default order;



// WEBPACK FOOTER //
// ./src/api/order.js